import { useEffect, useState } from 'react';

import journey from './mocks/journey.json';

export const useFetchJourney = () => {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (loading) {
      setTimeout(() => setLoading(false), 800);
    }
  });
  return {
    loading,
    journey,
  };
};
